import React, { Fragment, useEffect, useReducer } from "react";
import { Row, Col } from "react-bootstrap";
import { Currency } from "../lib/components/Currency";
import { WithApiAccess } from "../lib/HigherOrderComponents/WithApiAccess";
import { LoadingSpinner } from "../lib/components/LoadingSpinner";
import { FormattedDate } from "../lib/components/FormattedDate";
import { Address } from "../lib/components/Address";
import { withHeaderMessages } from "../higherOrderComponents/WithHeaderMessages";
import { useParams } from "react-router-dom";
import "./clearpoint-reports.css";

const CoupLetterPrint = (props) => {
  const initialState = {
    isLoading: true,
    contract: {
      provider: {
        address: {},
      },
      purchaser: {
        address: {},
      },
      recipients: [],
    },
  };

  const reducer = (state, action) => {
    switch (action.type) {
      case "contractDetails":
        return {
          ...state,
          contract: action.payload,
          isLoading: false,
        };
      case "isLoading":
        return {
          ...state,
          isLoading: action.payload,
        };
      case "hideLoader":
        return {
          ...state,
          isLoading: false,
        };
      default:
        throw new Error();
    }
  };

  const [coupLetterState, dispatch] = useReducer(reducer, initialState);
  const { number } = useParams();

  useEffect(() => {
    async function getContractDetails() {
      props.header.setHeader("confirmationReceiptPrint");
      await props.api
        .get(`/api/contract/${number}`)
        .then((response) => {
          if (response.status === 200) {
            return response.data;
          }
        })
        .then((data) => {
          dispatch({ type: "contractDetails", payload: data });
        })
        .catch(hideLoader)
        .then(hideLoader);
    }
    getContractDetails();
  }, []);

  const hideLoader = () => {
    dispatch({ type: "hideLoader" });
  };

  const getCurrentDate = () => {
    const currentDate = new Date();
    return <FormattedDate date={currentDate} format="M/D/YYYY" />;
  };

  if (coupLetterState.isLoading) {
    return <LoadingSpinner />;
  }

  const { contract } = coupLetterState;
  const recipient =
    contract.recipients.length > 0
      ? contract.recipients[0]
      : { firstName: "", lastName: "", address: {} };
  const isIrrevocable = contract.irrevocable ? "Yes" : "No";
  const providerType =
    contract.provider && contract.provider.providerType === 1
      ? "Funeral"
      : "Cemetery";
  var customLogo = contract?.provider?.providerLogo;

  return (
    <Fragment className="coup-letter">
      <Row>
        <Row>
          <Row>
            {customLogo ? (
              <Col xs={12} className="logo-container">
                <div className="receipt-header__inner justify-content-center">
                  <div className="receipt-header__logo-wrap">
                    <img
                      src={`data:${customLogo.contentType};base64,${customLogo.logoBase64}`}
                      alt="Customer logo"
                      className="receipt-header__logo__bigger"
                    />
                  </div>
                </div>
              </Col>
            ) : (
              <Col xs={12} style={{ textAlign: "center" }}>
                <img
                  src="/images/Clearpoint_Confirmation_Receipt_Logo.png"
                  alt="header"
                  className="confirmation-img"
                />
              </Col>
            )}
          </Row>
        </Row>
        <Col xs={11}>
          <Row className="coup-letter-headings">
            <Col>
              <div>{getCurrentDate()}</div>
            </Col>
          </Row>
          <Row className="coup-letter-headings">
            <Col>
              <div>
                {contract.purchaser.firstName} {contract.purchaser.lastName}
                <br />
                <Address address={contract.purchaser.address} />
              </div>
            </Col>
          </Row>
          <Row className="coup-letter-info">
            <Col>
              Trust Number: {contract.number}
              <br />
            </Col>
          </Row>
          <Row className="coup-letter-p">
            <Col>
              <div>
                The following information describes the current status of your
                preneed {providerType.toLowerCase()} trust with ClearPoint
                Federal Bank & Trust as of {getCurrentDate()}, which was
                purchased to fund a {providerType.toLowerCase()} plan with:{" "}
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="text-center">
              <div>
                <label>{contract.provider.name}</label>
              </div>
            </Col>
          </Row>
        </Col>
        <Col>
          <Row className="coup-letter-info">
            <Col>
              {providerType} Recipient: {recipient.firstName}{" "}
              {recipient.lastName}
            </Col>
          </Row>
          <Row className="coup-letter-info">
            <Col>
              {providerType} Purchaser: {contract.purchaser.firstName}{" "}
              {contract.purchaser.lastName}
            </Col>
          </Row>
          <Row className="coup-letter-info">
            <Col>
              Accepted Date:{" "}
              <FormattedDate date={contract.accepted} format="MMMM D, YYYY" />
            </Col>
          </Row>
          {/* not sure about using net price for plan amount */}
          <Row className="coup-letter-info">
            <Col>
              {providerType} Plan Amount:{" "}
              <Currency amount={contract.netPrice} />
            </Col>
          </Row>
          <Row className="coup-letter-info">
            <Col>
              Cash Applied to Plan Amount: <Currency amount={contract.paid} />
            </Col>
          </Row>
          <Row className="coup-letter-info">
            <Col>
              Balance Due: <Currency amount={contract.balance} />
            </Col>
          </Row>
          <Row className="coup-letter-info">
            <Col>Irrevocable: {isIrrevocable}</Col>
          </Row>
        </Col>
      </Row>
      <Row className="coup-letter-p">
        <p>
          Please contact {contract.provider.name} to obtain any additional
          information that you may need. Should you have any questions regarding
          the contents of this letter, please contact our Customer Service
          Department at 1-800-763-0234.
        </p>
      </Row>
      <Row>
        <Col xs={12}>
          <Row className="coup-letter-p">
            <div>Sincerely,</div>
            <div style={{ marginTop: ".3in" }}>
              ClearPoint Federal Bank & Trust
            </div>
          </Row>
        </Col>
      </Row>
    </Fragment>
  );
};

export default withHeaderMessages(WithApiAccess(CoupLetterPrint));
